<script lang="ts">
  import {DiamondSector} from '../../types/project';
  import {diamondMaxValue, diamondTriangles} from '../../constants/diamond';

  export let diamond: Record<DiamondSector, 0 | 1 | 2 | 3 | 4>;
  export let showAxesAndLabels: boolean | undefined = undefined;
</script>

<style lang="postcss">
  .container {
    position: relative;
    display: flex;
  }

  .container svg {
    width: 100%;
    height: 100%;
  }

  .axesAndlabels {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .axesAndlabels::before,
  .axesAndlabels::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    background-color: #000;
  }

  .axesAndlabels::before {
    top: 50%;
    width: 100%;
    height: 1px;
    transform: translateY(-50%);
  }

  .axesAndlabels::after {
    left: 50%;
    width: 1px;
    height: 100%;
    transform: translateX(-50%);
  }

  .axesAndlabels > span {
    z-index: 10;
    position: absolute;
    width: 3.5rem;
    height: 1.5rem;
    display: flex;
    padding: 0.25rem;
    background-color: var(--ubilabs-white);
    font-size: 0.75rem;
  }

  .web {
    top: 0;
    align-items: end;
  }

  .location {
    right: 0;
    justify-content: start;
  }

  .cloud {
    bottom: 0;
    align-items: start;
  }

  .data {
    justify-content: end;
  }

  .web,
  .cloud {
    left: 50%;
    transform: translateX(-50%);
    justify-content: center;
  }

  .location,
  .data {
    top: 50%;
    transform: translateY(-50%);
    align-items: center;
  }

  .diamondWithPadding {
    padding: 2rem 4rem;
  }
</style>

{#if Object.values(diamond).some(value => value > 0)}
  <div class="container">
    {#if showAxesAndLabels}
      <div class="axesAndlabels">
        <span class="web">{DiamondSector.WEB}</span>
        <span class="location">{DiamondSector.LOCATION}</span>
        <span class="cloud">{DiamondSector.CLOUD}</span>
        <span class="data">{DiamondSector.DATA}</span>
      </div>
    {/if}

    <svg
      class:diamondWithPadding={showAxesAndLabels != null}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 {diamondMaxValue * 2} {diamondMaxValue * 2}">
      {#each diamondTriangles as { getPath, color }}
        <path d={getPath(diamond)} fill={color} />
      {/each}
    </svg>
  </div>
{/if}
